import { 
    Button, 
    Flex, 
} from "@chakra-ui/react";
import { Table } from "antd";
import { Avatar } from "../../components/Avatar";
import { useState } from "react";
import { toDoTransferData } from ".";
import { formatCurrency } from "../../utils";
import { ColumnsType } from "antd/lib/table";
import { useTransfer } from "../../hooks/useTransfer";
import { SwapIcon } from "../../styles/icons/SwapIcon";
import { CreateTransferModal } from "./_createTransferModal";
interface ToDoParams {
    toDoTransfers: Array<toDoTransferData>;
    ref: any;
}

export function ToDo({
  toDoTransfers,
  ref
}: ToDoParams) {
    const { postToDoTransfers } = useTransfer();
    const [transferModalState, setTransferModalState] = useState<boolean>(false);
    const [selectedSeller, setSelectedSeller] = useState<toDoTransferData>({} as toDoTransferData);

    function handleClickTransfers(selectedSeller) {
        setTransferModalState(true);
        setSelectedSeller(selectedSeller);
    }

    const toDo: ColumnsType<any> = [
        {
            key: "sellerName",
            title: "Seller",
            dataIndex: "sellerName",
            render: (sellerAccountancy, record) => (
            <div>
                <Avatar name={record?.sellerAccountancy?.sellerName} />
            </div>
            )
        },
        {
            key: "pixKey",
            title: "PIX",
            dataIndex: "pixKey",
            render: (sellerAccountancy, record) => (
            <p>{record?.sellerAccountancy?.pixKey}</p>
            )
        },
        {
            key: "amount",
            title: "Saldo",
            dataIndex: "amount",
            render: (amount) => (
            <p>{formatCurrency({ value: amount })}</p>
            )
        },
        {
            key:"",
            title:"",
            dataIndex:  "",
            render: (record) => (
            <Button
                maxH="24px"
                fontSize="14px"
                borderRadius="3"
                bgColor="white"
                color="#000"
                border="1px solid"
                onClick={() => handleClickTransfers(record)}
                p="2"
                transition="all ease 0.2s"
                _hover={{
                   filter: "brightness(.9)"
                }}
            >
                <Flex
                    align="center"
                >
                    <SwapIcon />
                    Repassar
                </Flex>
            </Button>
            ) 
        }
    ]

  
    return (
        <>
            <CreateTransferModal 
                isOpen={transferModalState}
                onClose={() => setTransferModalState(!transferModalState)}
                apiFunction={postToDoTransfers}
                selectedSeller={selectedSeller}
            />
            <Table<any>
                columns={toDo}
                dataSource={toDoTransfers}
                rowKey={(record) => record?.key}
                locale={{ emptyText: "Sem repasses a serem feitos!" }}
            />
        </>
    )
}